export interface IframeParams {
  mode: string
  email: string
  ticket_number: string
}

export const isIframeRequest = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  const urlParams = new URLSearchParams(window.location.search)

  return urlParams.get('mode') === 'zendesk'
}

export const getIframeParams = (): IframeParams | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const urlParams = new URLSearchParams(window.location.search)
  const mode = urlParams.get('mode')
  const email = urlParams.get('email')
  const ticket_number = urlParams.get('ticket_number')

  if (mode === 'zendesk' && email && ticket_number) {
    return {
      mode,
      email,
      ticket_number
    }
  }

  return null
}

export const clearIframeParams = (): void => {
  if (typeof window === 'undefined') {
    return
  }

  const url = new URL(window.location.href)
  url.searchParams.delete('mode')
  url.searchParams.delete('email')
  url.searchParams.delete('ticket_number')

  window.history.replaceState({}, '', url.toString())
}

export const isIframeContext = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

// Store iframe parameters in localStorage for persistence across login flow
export const storeIframeParams = (params: IframeParams): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    localStorage.setItem('iframe_params', JSON.stringify(params))
  } catch (error) {
    // Failed to store iframe params
  }
}

// Retrieve stored iframe parameters from localStorage
export const getStoredIframeParams = (): IframeParams | null => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const stored = localStorage.getItem('iframe_params')

    return stored ? JSON.parse(stored) : null
  } catch (error) {
    // Failed to retrieve stored iframe params

    return null
  }
}

// Clear stored iframe parameters from localStorage
export const clearStoredIframeParams = (): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    localStorage.removeItem('iframe_params')
  } catch (error) {
    // Failed to clear stored iframe params
  }
}

// Clear only email and mode, but keep ticket number for refund purposes
export const clearStoredIframeParamsExceptTicket = (): void => {
  if (typeof window === 'undefined') {
    return
  }

  try {
    const stored = localStorage.getItem('iframe_params')
    if (stored) {
      const params = JSON.parse(stored)

      // Keep only the ticket number
      const ticketParams = {
        mode: null,
        email: null,
        ticket_number: params.ticket_number
      }
      localStorage.setItem('iframe_params', JSON.stringify(ticketParams))
    }
  } catch (error) {
    // Failed to clear stored iframe params except ticket
  }
}
